import request from '@/config';

enum Apis {
	Createion = '/api/basicstamp/createion',
	Modify = '/api/basicstamp/modify',
	Delete = '/api/basicstamp/deletebyid',
	Detail = '/api/basicstamp/getdetail',
	List = '/api/basicstamp/getdatalist',
	DropDownList = `/api/basicstamp/getstampdropdownlist`,
	UseStamp = `/api/basicstamp/getstampuselog`,
	StampUseLog = `/api/basicstamp/getstampusinglog`,
	StampListCache = `/api/basicstamp/getstamplistbycache`,
}

export const GetStampCacheListApi = (): Promise<IResponse> => request.post({ url: Apis.StampListCache, data: {} });

export const StampUseLogApi = (createData: any): Promise<IResponse> => request.post({ url: Apis.StampUseLog, data: createData });

export const StampCreateApi = (createData: any): Promise<IResponse> => request.post({ url: Apis.Createion, data: createData });

export const StampModifyApi = (editData: any): Promise<IResponse> => request.post({ url: Apis.Modify, data: editData });

export const StampDeleteApi = (delData: any): Promise<IResponse> => request.post({ url: Apis.Delete, data: delData });

export const GetStampDetailApi = (rowId: string): Promise<IResponse> => request.post({ url: Apis.Detail, data: { id: rowId } });

export const GetStampListApi = (search: any): Promise<IResponse> => request.post({ url: Apis.List, data: search });

export const GetStampDpListApi = (search: any): Promise<IResponse> => request.post({ url: Apis.DropDownList, data: search });

export const GetStampUseInfoApi = (ctId: string): Promise<IResponse> => request.post({ url: Apis.UseStamp, data: { contract_id: ctId } });
